<template>
  <CContainer class="pt-5" fluid>
    <CRow>
      <CCol class="col-7">
        <h3 class="pl-3 mb-0 pb-0">User</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item active>
            <CIcon name="cil-user" />
            User
          </b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
      <CCol class="col-5">
        <CButton color="primary" class="float-right mt-2" @click="showCreateUserModal">
          Create <FaIcon icon="plus" />
        </CButton>
      </CCol>
    </CRow>
    <CCard class="custom-card" v-if="$helper.isRole($availRoles['FIMS']) || $helper.isRole($availRoles['HO'])">
      <CCardBody class="px-0 pb-0">
        <CRow>
          <CCol class="ml-5">
            <CForm>
              <b-input-group>
                <b-input-group-prepend>
                  <b-form-select v-model="userTable.filterType" :options="userTable.filterOptions" @change="onChangeFilterType"></b-form-select>
                </b-input-group-prepend>
                <b-input-group-prepend>
                  <b-form-input maxlength="50" v-if="userTable.filterType == 'id'" type="text" placeholder="Search" v-model="userTable.filterValue" onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 13"></b-form-input>
                  <b-form-select v-else-if="userTable.filterType == 'isLocked'" v-model="userTable.filterValue" :options="userTable.filterValueIsLockedOptions" style="min-width: 206.5px;"></b-form-select>
                  <b-form-input maxlength="50" v-else type="text" placeholder="Search" v-model="userTable.filterValue"></b-form-input>
                </b-input-group-prepend>
                <b-input-group-append>
                  <CButton size="sm" color="primary" type="submit" style="color: white;" class="btn-icon mr-2 custom-button-action" @click="filterTable">
                    <CIcon name="cil-magnifying-glass" />
                  </CButton>
                </b-input-group-append>
              </b-input-group>
            </CForm>
          </CCol>
        </CRow>
        <CRow class="mt-4" v-if="$helper.isRole($availRoles['FIMS']) || $helper.isRole($availRoles['HO'])">
          <CCol>
            <b-table striped hover show-empty
              responsive="xl"
              :items="userTable.items"
              :fields="userTable.fields"
              :busy="!userTable.isLoaded"
              no-local-sorting no-sort-reset
              @sort-changed="onSortChanged"
            >
              <template slot="empty">
                <div v-if="!userTable.isLoaded" class="text-center">
                  <b-spinner label="Fetching Data..."></b-spinner>
                </div> 
                <div v-else class="text-center">
                  Tidak ada data
                </div> 
              </template>
              <template #cell(isLocked)="row">
                  <span v-if="row.value == true">Y</span>
                  <span v-else>N</span>
              </template>
              <template #cell(action)="row">
                <CButton v-if="row.item.source.toLowerCase() != 'hcms'" size="sm" color="warning" style="color: white;" @click="showEditUserModal(row.item.id, row.item.fullName, row.item.username, row.item.jobCode, row.item.jobName)" class="btn-icon mr-2 custom-button-action">
                  <CIcon name="cil-pencil" />
                </CButton> 
                <CButton v-if="row.item.source.toLowerCase() != 'hcms'" size="sm" color="primary" @click="showResetPasswordModal(row.item.id, row.item.fullName, row.item.username, row.item.isLocked)" class="btn-icon mr-2 custom-button-action">
                  <CIcon name="cil-sync" />
                </CButton>
                <span v-if="row.item.role != 'HO'">
                  <CButton v-if="row.item.isLocked == true" @click="showLockUnlockUserModal(row.item.id, row.item.fullName, row.item.username, row.item.isLocked)" size="sm" color="primary" class="btn-icon mr-2 custom-button-action">
                    <CIcon name="cil-lock-unlocked" />
                  </CButton>
                  <CButton v-else size="sm" color="danger" @click="showLockUnlockUserModal(row.item.id, row.item.fullName, row.item.username, row.item.isLocked)" class="btn-icon mr-2 custom-button-action">
                    <CIcon name="cil-lock-locked" />
                  </CButton>
                </span>
                <!-- <CButton size="sm" color="success" class="custom-button-action" v-if="row.item.role.toLowerCase() == 'notaris'" @click="assignNotaryToUser(row.item.id)">
                  Assign Notaris
                </CButton> -->
                <CButton size="sm" color="success" class="custom-button-action" v-if="row.item.role.toLowerCase() == 'cabang'" @click="assignOfficeToUser(row.item.id)">
                  Assign Office
                </CButton>
              </template>
            </b-table>
            <CCardFooter>
              <PageSizer :totalRows="userTable.totalRows" :page="userTable.currentPage" :options="tablePageOptions" @limit-change="onLimitChange" @page-change="onPageChange" />
            </CCardFooter>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>

    <CModal
      color="primary"
      :show.sync="showErrorModal" :centered="true" :closeOnBackdrop="false">
      <div slot="header"><h5>{{errorTitle}}</h5></div>
      <div class="body">
        {{errorLabel}}
      </div>
      <div slot="footer">
        <CButton v-if="errorLogout" color="primary" @click="$router.push({name: 'Login'})">Login</CButton>
        <CButton v-else color="primary" @click="showErrorModal = false">OK</CButton>
      </div>
    </CModal>

    <CModal :closeOnBackdrop="false" :show.sync="showConfirmLockUnlockUserModal" :centered="true">
      <div slot="header"><h5>Konfirmasi {{ (lockUnlockUser.lock) ? 'Kunci' : 'Buka Kunci' }} Akun</h5></div>
      <div class="body">
        <CRow class="mb-2">
          <CCol>
            Apakah Anda yakin ingin {{ (lockUnlockUser.lock) ? 'mengunci' : 'membuka kunci' }} Akun berikut?
          </CCol>
        </CRow>
        <CRow>
          <CCol md="4" sm="5">
            ID User
          </CCol>
          <CCol md="8" sm="7">
            : {{ lockUnlockUser.id }}
          </CCol>
        </CRow>
        <CRow>
          <CCol md="4" sm="5">
            Nama Lengkap
          </CCol>
          <CCol md="8" sm="7">
            : {{ lockUnlockUser.fullName }}
          </CCol>
        </CRow>
        <CRow>
          <CCol md="4" sm="5">
            Username
          </CCol>
          <CCol md="8" sm="7">
            : {{ lockUnlockUser.username }}
          </CCol>
        </CRow>
      </div>
      <div slot="footer">
        <CButton color="primary" @click="showConfirmLockUnlockUserModal = false">Batal</CButton>
        <CButton class="ml-2" color="danger" @click="confirmLockUnlockUser" :disabled="isLoading.confirmLockUnlockUser">
          <b-spinner small type="grow" v-if="isLoading.confirmLockUnlockUser" /> 
          {{ isLoading.confirmLockUnlockUser ? 'Sedang diproses...' : 'Ya' }}
        </CButton>
      </div>
    </CModal>

    <CModal :closeOnBackdrop="false" :show.sync="showConfirmResetPasswordModal" :centered="true">
      <div slot="header"><h5>Konfirmasi Reset Password Akun</h5></div>
      <div class="body">
        <CRow class="mb-2">
          <CCol>
            Apakah Anda yakin ingin Reset Password Akun berikut?
          </CCol>
        </CRow>
        <CRow>
          <CCol md="4" sm="5">
            ID User
          </CCol>
          <CCol md="8" sm="7">
            : {{ lockUnlockUser.id }}
          </CCol>
        </CRow>
        <CRow>
          <CCol md="4" sm="5">
            Nama Lengkap
          </CCol>
          <CCol md="8" sm="7">
            : {{ lockUnlockUser.fullName }}
          </CCol>
        </CRow>
        <CRow>
          <CCol md="4" sm="5">
            Username
          </CCol>
          <CCol md="8" sm="7">
            : {{ lockUnlockUser.username }}
          </CCol>
        </CRow>
      </div>
      <div slot="footer">
        <CButton color="primary" @click="showConfirmResetPasswordModal = false">Batal</CButton>
        <CButton class="ml-2" color="danger" @click="confirmResetPassword" :disabled="isLoading.confirmResetPassword">
          <b-spinner small type="grow" v-if="isLoading.confirmResetPassword" /> 
          {{ isLoading.confirmResetPassword ? 'Sedang diproses...' : 'Ya' }}
        </CButton>
      </div>
    </CModal>

    <CForm>
      <CModal :closeOnBackdrop="false" :show.sync="showCreateEditkUserModal" :centered="true">
        <div slot="header"><h5>{{ (createEditUserAction == 'create') ? 'Create' : 'Edit' }} User</h5></div>
        <div class="body">
          <CRow class="mb-2">
            <CCol sm="12">
              <b-form-group
                invalid-feedback="This input is required."
                label="Username"
                label-for="user-username"
                :state="createEditUser.username.isValid"
              >
                <b-form-input
                  v-model="createEditUser.username.value"
                  :state="createEditUser.username.isValid"
                  placeholder="Username"
                  maxlength="50"
                  id="user-username"
                  ref="username"
                ></b-form-input>
              </b-form-group>
            </CCol>
          </CRow>
          <CRow class="mb-2" v-if="createEditUserAction == 'edit'">
            <CCol sm="12">
              <b-form-group
                :invalid-feedback="createEditUser.password.feedback"
                label="Password"
                label-for="user-password"
                :state="createEditUser.password.isValid"
              >
                <CButton color="secondary" variant="outline" @click="showEditPasswordModal = true; showCreateEditkUserModal = false; resetEditPasswordUserFields();">Change Password</CButton>
              </b-form-group>
            </CCol>
          </CRow>
          <CRow class="mb-2" v-if="createEditUserAction == 'create'">
            <CCol sm="12">
              <b-form-group
                :invalid-feedback="createEditUser.password.feedback"
                label="Password"
                label-for="user-password"
                :state="createEditUser.password.isValid"
              >
                <b-form-input
                  type="password"
                  v-model="createEditUser.password.value"
                  :state="createEditUser.password.isValid"
                  placeholder="Password"
                  maxlength="50"
                  id="user-password"
                ></b-form-input>
              </b-form-group>
            </CCol>
          </CRow>
          <CRow class="mb-2" v-if="createEditUserAction == 'create'">
            <CCol sm="12">
              <b-form-group
                :invalid-feedback="createEditUser.confirmPassword.feedback"
                label="Confirm Password"
                label-for="user-confirmPassword"
                :state="createEditUser.confirmPassword.isValid"
              >
                <b-form-input
                  type="password"
                  v-model="createEditUser.confirmPassword.value"
                  :state="createEditUser.confirmPassword.isValid"
                  placeholder="Confirm Password"
                  maxlength="50"
                  id="user-confirmPassword"
                ></b-form-input>
              </b-form-group>
            </CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="12">
              <b-form-group
                invalid-feedback="This input is required."
                label="Full Name"
                label-for="user-fullName"
                :state="createEditUser.fullName.isValid"
              >
                <b-form-input
                  v-model="createEditUser.fullName.value"
                  :state="createEditUser.fullName.isValid"
                  placeholder="Full Name"
                  maxlength="240"
                  id="user-fullName"
                ></b-form-input>
              </b-form-group>
            </CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="12">
              <b-form-group
                invalid-feedback="This input is required."
                label="Job Code"
                label-for="user-jobcode"
                :state="createEditUser.jobCode.isValid"
              >
                <multiselect 
                  v-model="createEditUser.jobCode.value" 
                  :options="createEditUser.jobCode.options" 
                  :state="createEditUser.jobCode.isValid"
                  :class="{custom_multiselect_invalid: createEditUser.jobCode.isValid === false}"
                  id="user-jobcode"
                  placeholder="Select a Job Code"
                  :showLabels="false"
                  :loading="!createEditUser.jobCode.isLoaded"
                  openDirection="bottom"
                  label="jobName"
                  track-by="jobCode"
                  :internalSearch="false"
                  :preserveSearch="false"
                  :disabled="editUserLockJobCode"
                  @search-change="populateSelectJobCode"
                >
                  <template slot="singleLabel" slot-scope="props">{{ props.option.jobName }}</template>
                  <template slot="option" slot-scope="props">{{ props.option.jobName }}</template>
                  <template slot="noResult">No elements found.</template>
                  <template slot="afterList" v-if="createEditUser.jobCode.currentPage < createEditUser.jobCode.totalPages">
                    <div class="text-center custom-cursor-clickable p-2" @click="appendSelectJobCode" v-if="createEditUser.jobCode.isLoaded">
                      <span class="text-muted">Load More</span>
                    </div>
                    <div class="text-center" v-else>
                      <b-spinner small variant="primary" class="m-2 mt-3" label="Loading more options..."></b-spinner>
                    </div>
                  </template>
                </multiselect>
              </b-form-group>
            </CCol>
          </CRow>
        </div>
        <div slot="footer">
          <CButton color="primary" variant="outline" @click="showCreateEditkUserModal = false">Back</CButton>
          <CButton class="ml-2" v-if="createEditUserAction == 'create'" color="primary" type="submit" @click="createUser" :disabled="isLoading.createEditUser">
            <b-spinner small type="grow" v-if="isLoading.createEditUser" /> 
            {{ isLoading.createEditUser ? 'Loading...' : 'Save' }}
          </CButton>
          <CButton class="ml-2" v-else color="primary" type="submit" @click="editUser" :disabled="isLoading.createEditUser">
            <b-spinner small type="grow" v-if="isLoading.createEditUser" /> 
            {{ isLoading.createEditUser ? 'Loading...' : 'Save' }}
          </CButton>
        </div>
      </CModal>
    </CForm>

    <CForm>
      <CModal :closeOnBackdrop="false" size="sm" :show.sync="showEditPasswordModal" :centered="true">
        <div slot="header"><h5>Change Password</h5></div>
        <div class="body">
          <CRow class="mb-2">
            <CCol sm="12">
              <b-form-group
                :invalid-feedback="editPasswordUser.currentPassword.feedback"
                label="Current Password"
                label-for="user-currentPassword"
                :state="editPasswordUser.currentPassword.isValid"
              >
                <b-form-input
                  type="password"
                  v-model="editPasswordUser.currentPassword.value"
                  :state="editPasswordUser.currentPassword.isValid"
                  placeholder="Current Password"
                  maxlength="50"
                  id="user-currentPassword"
                ></b-form-input>
              </b-form-group>
            </CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="12">
              <b-form-group
                :invalid-feedback="editPasswordUser.newPassword.feedback"
                label="New Password"
                label-for="user-newPassword"
                :state="editPasswordUser.newPassword.isValid"
              >
                <b-form-input
                  type="password"
                  v-model="editPasswordUser.newPassword.value"
                  :state="editPasswordUser.newPassword.isValid"
                  placeholder="New Password"
                  maxlength="50"
                  id="user-newPassword"
                ></b-form-input>
              </b-form-group>
            </CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="12">
              <b-form-group
                :invalid-feedback="editPasswordUser.confirmNewPassword.feedback"
                label="Confirm New Password"
                label-for="user-confirmNewPassword"
                :state="editPasswordUser.confirmNewPassword.isValid"
              >
                <b-form-input
                  type="password"
                  v-model="editPasswordUser.confirmNewPassword.value"
                  :state="editPasswordUser.confirmNewPassword.isValid"
                  placeholder="Confirm New Password"
                  maxlength="50"
                  id="user-confirmNewPassword"
                ></b-form-input>
              </b-form-group>
            </CCol>
          </CRow>
        </div>
        <div slot="footer">
          <CButton color="primary" variant="outline" @click="showCreateEditkUserModal = true; showEditPasswordModal = false">Back</CButton>
          <CButton class="ml-2" color="primary" type="submit" @click="editUserPassword" :disabled="isLoading.editPassword">
            <b-spinner small type="grow" v-if="isLoading.editPassword" /> 
            {{ isLoading.editPassword ? 'Loading...' : 'Change Password' }}
          </CButton>
        </div>
      </CModal>
    </CForm>

    <!-- <CModal :closeOnBackdrop="false" size="lg" :show.sync="showAssignNotaryModal" :centered="true">
      <div slot="header"><h5>Assign Notaris to User</h5></div>
      <div class="body">
        <CForm>
          <CRow class="mb-2">
            <CCol sm="6">
              <b-form-group
                label="Search By"
                label-for="user-assignNotary-searchBy"
              >
                <b-form-select 
                  v-model="assignNotaryTable.filterType"
                  :options="assignNotaryTable.filterOptions"
                  @change="onChangeFilterType"
                  id="user-assignNotary-searchBy"
                ></b-form-select>
              </b-form-group>
            </CCol>
            <CCol sm="6">
              <b-form-group
                label="Search Value"
                label-for="user-assignNotary-searchValue"
              >
                <b-input-group>
                  <b-input-group-prepend>
                    <b-form-input
                      type="text"
                      v-model="assignNotaryTable.filterValue"
                      placeholder="Search Value"
                      id="user-assignNotary-searchValue"
                    ></b-form-input>
                  </b-input-group-prepend>
                  <b-input-group-append>
                    <CButton size="sm" color="primary" style="color: white;" class="btn-icon mr-2 custom-button-action" type="submit" @click="filterassignNotaryTable">
                      <CIcon name="cil-magnifying-glass" />
                    </CButton>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </CCol>
          </CRow>
        </CForm>
        <CRow>
          <CCol sm="12">
            <div class="mb-4">
              <b-table striped hover show-empty
                responsive="xl"
                :items="assignNotaryTable.items"
                :fields="assignNotaryTable.fields"
                :busy="!assignNotaryTable.isLoaded"
                no-local-sorting no-sort-reset
                @sort-changed="onAssignNotarySortChanged"
              >
                <template slot="empty">
                  <div v-if="!assignNotaryTable.isLoaded" class="text-center">
                    <b-spinner label="Fetching Data..."></b-spinner>
                  </div> 
                  <div v-else class="text-center">
                    Belum ada Notaris yang diassign di User ini.
                    <br>
                    <strong>Silahkan tekan tombol Search</strong>
                  </div> 
                </template>
                <template #cell(action)="row">
                  <b-form-checkbox size="md" v-on:change="setCurrentNotaryCode(row.item.code)" @change="addRemoveSelectedNotaryCode" :checked="assignNotaryTable.selectedNotaryCodes.indexOf(row.item.code) != -1"></b-form-checkbox>
                </template>
              </b-table>
              <PageSizer v-if="assignNotaryTable.manualSearched" :totalRows="assignNotaryTable.totalRows" :page="assignNotaryTable.currentPage" :options="tablePageOptions" @limit-change="onAssignNotaryLimitChange" @page-change="onAssignNotaryPageChange" />
            </div>
            <b-alert show variant="warning" class="mt-2">
              Apabila Notaris yang dipilih sebelumnya sudah terhubung ke User lain, maka Notaris tersebut secara otomatis akan dihapus dari User lama dan dihubungkan ke User baru.
            </b-alert>
          </CCol>
        </CRow>
      </div>
      <div slot="footer">
        <CButton color="primary" variant="outline" @click="showAssignNotaryModal = false">Cancel</CButton>
        <CButton class="ml-2" color="primary" @click="confirmAssignNotaryToUser" :disabled="isLoading.assignNotaryToUser">
          <b-spinner small type="grow" v-if="isLoading.assignNotaryToUser" /> 
          {{ isLoading.assignNotaryToUser ? 'Sedang diproses...' : 'Save' }}
        </CButton>
      </div>
    </CModal> -->

    <CModal :closeOnBackdrop="false" size="lg" :show.sync="showAssignOfficeModal" :centered="true">
      <div slot="header"><h5>Assign Office to User</h5></div>
      <div class="body">
        <CForm>
          <CRow class="mb-2">
            <CCol sm="6">
              <b-form-group
                label="Search By"
                label-for="user-assignOffice-searchBy"
              >
                <b-form-select 
                  v-model="assignOfficeTable.filterType"
                  :options="assignOfficeTable.filterOptions"
                  @change="onChangeFilterType"
                  id="user-assignOffice-searchBy"
                ></b-form-select>
              </b-form-group>
            </CCol>
            <CCol sm="6">
              <b-form-group
                label="Search Value"
                label-for="user-assignOffice-searchValue"
              >
                <b-input-group>
                  <b-input-group-prepend>
                    <b-form-input
                      type="text"
                      v-model="assignOfficeTable.filterValue"
                      maxlength="50"
                      placeholder="Search Value"
                      id="user-assignOffice-searchValue"
                    ></b-form-input>
                  </b-input-group-prepend>
                  <b-input-group-append>
                    <CButton size="sm" color="primary" style="color: white;" class="btn-icon mr-2 custom-button-action" type="submit" @click="filterAssignOfficeTable">
                      <CIcon name="cil-magnifying-glass" />
                    </CButton>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </CCol>
          </CRow>
        </CForm>
        <CRow>
          <CCol sm="12">
            <div class="mb-4">
              <b-table striped hover show-empty
                responsive="xl"
                :items="assignOfficeTable.items"
                :fields="assignOfficeTable.fields"
                :busy="!assignOfficeTable.isLoaded"
                no-local-sorting no-sort-reset
                @sort-changed="onAssignOfficeSortChanged"
              >
                <template slot="empty">
                  <div v-if="!assignOfficeTable.isLoaded" class="text-center">
                    <b-spinner label="Fetching Data..."></b-spinner>
                  </div> 
                  <div v-else class="text-center">
                    Belum ada Office yang diassign di User ini.
                    <br>
                    <strong>Silahkan tekan tombol Search</strong>
                  </div> 
                </template>
                <template #cell(action)="row">
                  <b-form-checkbox size="md" v-on:change="setCurrentOfficeCode(row.item.officeCode)" @change="addRemoveSelectedOfficeCode" :checked="assignOfficeTable.selectedOfficeCodes.indexOf(row.item.officeCode) != -1"></b-form-checkbox>
                </template>
              </b-table>
              <PageSizer v-if="assignOfficeTable.manualSearched" :totalRows="assignOfficeTable.totalRows" :page="assignOfficeTable.currentPage" :options="tablePageOptions" @limit-change="onAssignOfficeLimitChange" @page-change="onAssignOfficePageChange" />
            </div>
            <!-- <b-alert show variant="warning" class="mt-2">
              Apabila Office yang dipilih sebelumnya sudah terhubung ke User lain, maka Office tersebut secara otomatis akan dihapus dari User lama dan dihubungkan ke User baru.
            </b-alert> -->
          </CCol>
        </CRow>
      </div>
      <div slot="footer">
        <CButton color="primary" variant="outline" @click="showAssignOfficeModal = false">Cancel</CButton>
        <CButton class="ml-2" color="primary" @click="confirmAssignOfficeToUser" :disabled="isLoading.assignOfficeToUser">
          <b-spinner small type="grow" v-if="isLoading.assignOfficeToUser" /> 
          {{ isLoading.assignOfficeToUser ? 'Sedang diproses...' : 'Save' }}
        </CButton>
      </div>
    </CModal>
  </CContainer>
</template>

<script>
export default {
  name: 'UserList',
  data() {
    return {
      showConfirmLockUnlockUserModal: false,
      showConfirmResetPasswordModal: false,
      lockUnlockUser: {
        id: 0,
        name: "",
        username: "",
        lock: true
      },
      isLoading: {
        confirmLockUnlockUser: false,
        createEditUser: false,
        editPassword: false,
        // assignNotaryToUser: false,
        assignOfficeToUser: false,
        confirmResetPassword: false
      },
      showCreateEditkUserModal: false,
      createEditUserAction: 'create',
      editUserLockJobCode: false,
      selectedUserId: 0,
      createEditUser: {
        fullName: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "fullName"
        },
        username: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "username"
        },
        password: {
          value: '',
          feedback: 'This input is required.',
          isValid: null,
          isRequired: true,
          payloadKey: "password"
        },
        confirmPassword: {
          value: '',
          feedback: 'This input is required.',
          isValid: null,
          isRequired: true,
          payloadKey: "confirmPassword"
        },
        jobCode: {
          value: '',
          isLoaded: false,
          isValid: null,
          isRequired: true,
          options: [],
          currentPage: 1,
          perPage: 10,
          totalRows: 0,
          totalPages: 0,
          lastQuery: '',
          payloadKey: "jobCode"
        },
      },
      showEditPasswordModal: false,
      editPasswordUser: {
        currentPassword: {
          value: '',
          feedback: 'This input is required.',
          isValid: null,
          isRequired: true,
          payloadKey: "currentPassword"
        },
        newPassword: {
          value: '',
          feedback: 'This input is required.',
          isValid: null,
          isRequired: true,
          payloadKey: "newPassword"
        },
        confirmNewPassword: {
          value: '',
          feedback: 'Please repeat the same password.',
          isValid: null,
          isRequired: true
        },
      },
      showErrorModal: false,
      errorLogout: false,
      errorLabel: 'Unexpected Error',
      errorTitle: 'Error!',
      tablePageOptions: [
        { value: 10, text: '10'},
        { value: 20, text: '20'},
        { value: 30, text: '30'},
        { value: 40, text: '40'},
        { value: 50, text: '50'}
      ],
      userTable: {
        isLoaded: false,
        fields: [
          {key: "id", label: "ID User", sortable: true},
          {key: "fullName", label: "Nama Lengkap", sortable: true},
          {key: "username", label: "Username", sortable: true},
          {key: "jobName", label: "Job Name", sortable: true},
          {key: "role", label: "Role", sortable: true},
          {key: "isLocked", label: "Terkunci", sortable: true},
          {key: "source", label: "Sumber", sortable: true},
          { key: "action", label: "Aksi", sortable: false, class:"custom-column-action-user" }
        ],

        items: [],

        filterType: "id",
        filterOptions: [
          { value: "id", text: "ID User" },
          { value: "fullName", text: "Nama Lengkap" },
          { value: "username", text: "Username" },
          { value: "jobName", text: "Job" },
          { value: "role", text: "Role" },
          { value: "isLocked", text: "Terkunci" },
          { value: "source", text: "Sumber" }
        ],
        filterValue: "",
        filterValueIsLockedOptions: [
          { value: "true", text: "Y" },
          { value: "false", text: "N" },
        ],

        sort: {
          by: null,
          desc: false
        },

        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 0
      },
      showAssignNotaryModal: false,
      assignNotaryTable: {
        manualSearched: false,
        isLoaded: false,
        fields: [
          {key: "code", label: "ID Notaris", sortable: false},
          {key: "name", label: "Nama Notaris", sortable: false},
          {key: "officeCode", label: "Kode Office", sortable: false},
          {key: "officeName", label: "Nama Office", sortable: false},
          { key: "action", label: "Aksi", sortable: false, class:"custom-column-action-notary" }
        ],

        items: [],
        currenNotaryCode: '',
        selectedNotaryCodes: [],

        filterType: "code",
        filterOptions: [
          { value: "code", text: "ID Notaris" },
          { value: "name", text: "Nama Notaris" },
          { value: "officeCode", text: "Kode Office" },
          { value: "officeName", text: "Nama Office" }
        ],
        filterValue: "",

        sort: {
          by: null,
          desc: false
        },

        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 0
      },
      showAssignOfficeModal: false,
      assignOfficeTable: {
        manualSearched: false,
        isLoaded: false,
        fields: [
          {key: "officeCode", label: "Kode Office", sortable: false},
          {key: "nameFull", label: "Nama Office", sortable: false},
          { key: "action", label: "Aksi", sortable: false, class:"custom-column-action-notary" }
        ],

        items: [],
        currentOfficeCode: '',
        selectedOfficeCodes: [],

        filterType: "officeCode",
        filterOptions: [
          { value: "officeCode", text: "Kode Office" },
          { value: "nameFull", text: "Nama Office" }
        ],
        filterValue: "",

        sort: {
          by: null,
          desc: false
        },

        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 0
      },
    }
  },
  methods: {

    filterassignNotaryTable(event) {
      event.preventDefault()

      this.getAssignNotaryTableItems(this.assignNotaryTable.currentPage)
    },

    filterAssignOfficeTable(event) {
      event.preventDefault()

      this.getAssignOfficeTableItems(this.assignOfficeTable.currentPage)
    },

    filterTable(event) {
      event.preventDefault()

      this.getUserTableItems(this.userTable.currentPage)
    },

    addRemoveSelectedNotaryCode(checked) {
      if (checked) {
        this.assignNotaryTable.selectedNotaryCodes.push(this.assignNotaryTable.currentNotaryCode)
      } else{
        this.assignNotaryTable.selectedNotaryCodes.splice(this.assignNotaryTable.selectedNotaryCodes.indexOf(this.assignNotaryTable.currentNotaryCode), 1)
      }
    },

    addRemoveSelectedOfficeCode(checked) {
      if (checked) {
        this.assignOfficeTable.selectedOfficeCodes.push(this.assignOfficeTable.currentOfficeCode)
      } else{
        this.assignOfficeTable.selectedOfficeCodes.splice(this.assignOfficeTable.selectedOfficeCodes.indexOf(this.assignOfficeTable.currentOfficeCode), 1)
      }
    },

    setCurrentNotaryCode(code) {
      this.assignNotaryTable.currentNotaryCode = code
    },

    setCurrentOfficeCode(code) {
      this.assignOfficeTable.currentOfficeCode = code
    },

    // assignNotaryToUser(userId) {
    //   this.selectedUserId = userId
    //   this.assignNotaryTable.manualSearched = false
    //   this.showAssignNotaryModal = true
    //   this.populateSelectedNotaryByUserId(userId)
    // },

    assignOfficeToUser(userId) {
      this.selectedUserId = userId
      this.assignOfficeTable.manualSearched = false
      this.showAssignOfficeModal = true
      this.populateSelectedOfficeByUserId(userId)
    },

    populateSelectedNotaryByUserId(userId, page = 1) {
      this.assignNotaryTable.isLoaded = false
      this.assignNotaryTable.items = []
      if(isNaN(page)) {
        this.assignNotaryTable.currentPage = 1
      }
      else {
        this.assignNotaryTable.currentPage = page
      }
      // URL builder
      let getUrl = "/user/getAllNotaryByUserId"

      let params = {
        userId: userId
      }

      return this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){
          this.assignNotaryTable.selectedNotaryCodes = response.data.data.map(obj => obj.code)
          this.assignNotaryTable.items = response.data.data
        }
        else{
          // this.errorAction(response)
          this.$helper.toastError(this, "Load Daftar Notary Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        // this.errorAction(error)
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Daftar Notary Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Load Daftar Notary Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.assignNotaryTable.isLoaded = true
      })
    },

    populateSelectedOfficeByUserId(userId, page = 1) {
      this.assignOfficeTable.isLoaded = false
      this.assignOfficeTable.items = []
      if(isNaN(page)) {
        this.assignOfficeTable.currentPage = 1
      }
      else {
        this.assignOfficeTable.currentPage = page
      }
      // URL builder
      let getUrl = "/user/getAllOfficeByUserId"

      let params = {
        userId: userId
      }

      return this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){
          this.assignOfficeTable.selectedOfficeCodes = response.data.data.map(obj => obj.officeCode)
          this.assignOfficeTable.items = response.data.data
        }
        else{
          // this.errorAction(response)
          this.$helper.toastError(this, "Load Daftar Office Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        // this.errorAction(error)
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Daftar Office Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Load Daftar Office Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.assignOfficeTable.isLoaded = true
      })
    },

    getAssignNotaryTableItems(page = 1) {
      this.assignNotaryTable.isLoaded = false
      this.assignNotaryTable.items = []
      if(isNaN(page)) {
        this.assignNotaryTable.currentPage = 1
      }
      else {
        this.assignNotaryTable.currentPage = page
      }
      // URL builder 
      let getUrl = "/notary/getAll"
      
      let params = this.$helper.getBasePagedQuery(this.assignNotaryTable.currentPage - 1, this.assignNotaryTable.perPage)
      if(!this.$helper.isEmpty(this.assignNotaryTable.filterValue)) {
        params['filterType'] = this.assignNotaryTable.filterType
        params['filterValue'] = this.assignNotaryTable.filterValue
      }
      if(this.assignNotaryTable.sort.by != null) {
        params = this.$helper.getBaseSortQuery(this.assignNotaryTable.sort, params)
      }

      return this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){
          this.assignNotaryTable.items = response.data.data.data
          this.assignNotaryTable.totalRows = response.data.data.totalElements
          this.assignNotaryTable.totalPages = response.data.data.totalPages
        }
        else{
          // this.errorAction(response)
          this.$helper.toastError(this, "Load Daftar Notary Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        // this.errorAction(error)
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Daftar Notary Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Load Daftar Notary Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.assignNotaryTable.isLoaded = true
        this.assignNotaryTable.manualSearched = true
      })
    },

    getAssignOfficeTableItems(page = 1) {
      this.assignOfficeTable.isLoaded = false
      this.assignOfficeTable.items = []
      if(isNaN(page)) {
        this.assignOfficeTable.currentPage = 1
      }
      else {
        this.assignOfficeTable.currentPage = page
      }
      // URL builder
      let getUrl = "/office/getAll"
      
      let params = this.$helper.getBasePagedQuery(this.assignOfficeTable.currentPage - 1, this.assignOfficeTable.perPage)
      if(!this.$helper.isEmpty(this.assignOfficeTable.filterValue)) {
        params['filterType'] = this.assignOfficeTable.filterType
        params['filterValue'] = this.assignOfficeTable.filterValue
      }
      if(this.assignOfficeTable.sort.by != null) {
        params = this.$helper.getBaseSortQuery(this.assignOfficeTable.sort, params)
      }

      return this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){
          this.assignOfficeTable.items = response.data.data.data
          this.assignOfficeTable.totalRows = response.data.data.totalElements
          this.assignOfficeTable.totalPages = response.data.data.totalPages
        }
        else{
          // this.errorAction(response)
          this.$helper.toastError(this, "Load Daftar Office Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        // this.errorAction(error)
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Daftar Office Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Load Daftar Office Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.assignOfficeTable.isLoaded = true
        this.assignOfficeTable.manualSearched = true
      })
    },

    // confirmAssignNotaryToUser() {
    //   let obj = {
    //     userId: this.selectedUserId,
    //     notaryCodes: this.assignNotaryTable.selectedNotaryCodes
    //   }

    //   let postUrl = '/user/assignNotaryToUser/'
    //   // only send axios request if role is valid
    //   if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
    //     this.isLoading.assignNotaryToUser = true
    //     this.$axios.post(postUrl, obj).then(response => {
    //       if(response.status == 200){
    //         this.$helper.toastSuccess(this, "Assign Notaris to User Berhasil! " + (response.data.reason ? response.data.reason : ""))
    //       this.showAssignNotaryModal = false
    //       } else{
    //         this.$helper.toastError(this, "Assign Notaris to User Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
    //       }
    //     })
    //     .catch(error => {
    //       if(!this.$helper.isEmpty(error.response)){
    //       this.$helper.toastError(this, "Assign Notaris to User Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
    //     }
    //     else{
    //       this.$helper.toastError(this, "Assign Notaris to User Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
    //     }
    //     })
    //     .finally(() => {
    //       this.isLoading.assignNotaryToUser = false
    //     })
    //   }
    // },

    confirmAssignOfficeToUser() {
      let obj = {
        userId: this.selectedUserId,
        officeCodes: this.assignOfficeTable.selectedOfficeCodes
      }

      let postUrl = '/user/assignOfficeToUser/'
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.isLoading.assignOfficeToUser = true
        this.$axios.post(postUrl, obj).then(response => {
          if(response.status == 200){
            this.$helper.toastSuccess(this, "Assign Office to User Berhasil! " + (response.data.reason ? response.data.reason : ""))
          this.showAssignOfficeModal = false
          } else{
            this.$helper.toastError(this, "Assign Office to User Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Assign Office to User Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Assign Office to User Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
        })
        .finally(() => {
          this.isLoading.assignOfficeToUser = false
        })
      }
    },

    showCreateUserModal(event) {
      event.preventDefault()

      this.createEditUserAction = 'create'
      this.resetCreateEditUserFields()
      this.showCreateEditkUserModal = true
    },

    showEditUserModal(userId, fullName, username, jobCode, jobName) {
      this.resetCreateEditUserFields()
      this.selectedUserId = userId
      this.createEditUserAction = 'edit'
      this.createEditUser.username.value = username
      this.createEditUser.fullName.value = fullName
      this.createEditUser.jobCode.value = {
        jobCode: jobCode,
        jobName: jobName
      }
      if (jobCode == 'FIMS01') this.editUserLockJobCode = true

      this.showCreateEditkUserModal = true
    },

    resetCreateEditUserFields() {
      this.selectedUserId = 0
      this.editUserLockJobCode = false
      this.createEditUser.username.value = ''
      this.createEditUser.fullName.value = ''
      this.createEditUser.password.value = ''
      this.createEditUser.confirmPassword.value = ''
      this.createEditUser.jobCode.value = ''
      this.createEditUser.jobCode.lastQuery = ''
      for(const [key, data] of Object.entries(this.createEditUser)){
        data.isValid = null
      }
    },

    resetEditPasswordUserFields() {
      this.editPasswordUser.currentPassword.value = ''
      this.editPasswordUser.newPassword.value = ''
      this.editPasswordUser.confirmNewPassword.value = ''
    },

    editUserPassword(event) {
      event.preventDefault()

      this.isLoading.editPassword = true
      let isFormValid = true
      for(const [key, data] of Object.entries(this.editPasswordUser)){
        // Password Minimal 8 karakter, mengandung angka (0 - 9), huruf besar, huruf kecil, dan karakter khusus (+_)(*&^%$#@!~`[]\;‘,./<>?:“{}|)
        if (key == 'newPassword') {
          if (data.isRequired && this.$helper.isEmpty(data.value)) {
            data.feedback = "This input is required."
            isFormValid = false
            data.isValid = false
          } else if (data.value.length < 8) {
            data.feedback = "Password should contain a minimal 8 characters."
            isFormValid = false
            data.isValid = false
          } else if (!this.$helper.containsSmallLetter(data.value) || !this.$helper.containsCapitalLetter(data.value)) {
            data.feedback = "Password should contain small [a-z] and capital [A-Z] letter."
            isFormValid = false
            data.isValid = false
          } else if (!this.$helper.containsNumber(data.value)) {
            data.feedback = "Password should contain number [0-9]."
            isFormValid = false
            data.isValid = false
          } else if (!this.$helper.containsSpecialCharacter(data.value)) {
            data.feedback = "Password should contain special character [ `!@#$%^&*()_+-=[]{};':\"|,.<>/?~ ]."
            isFormValid = false
            data.isValid = false
          } else{
            data.isValid = null
          }
        } else if (key == 'confirmNewPassword') {
          // Repeat Password on confirm password field
          if (data.isRequired && this.$helper.isEmpty(data.value)) {
            data.feedback = "This input is required."
            isFormValid = false
            data.isValid = false
          } else if (data.value != this.editPasswordUser.newPassword.value) {
            data.feedback = "Please repeat the same password."
            isFormValid = false
            data.isValid = false
          } else{
            data.isValid = null
          }
        } else{
          // The rest of the field
          if (data.isRequired && this.$helper.isEmpty(data.value)) {
            isFormValid = false
            data.isValid = false
          } else{
            data.isValid = null
          }
        }
      }

      if (isFormValid) {
        let postUrl = '/user/changePassword/'
        // only send axios request if role is valid
        if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
          this.isSubmitting = true
          let data = new FormData()
          data.set('userId', this.selectedUserId)
          data.set('currentPassword', this.editPasswordUser.currentPassword.value)
          data.set('newPassword', this.editPasswordUser.newPassword.value)
          this.$axios.post(postUrl, data).then(response => {
            if(response.status == 200){
              this.$helper.toastSuccess(this, "Change Password Berhasil! " + (response.data.reason ? response.data.reason : ""))
              this.showCreateEditkUserModal = true
              this.showEditPasswordModal = false
            } else{
              this.$helper.toastError(this, "Change Password Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
            }
          })
          .catch(error => {
            if(!this.$helper.isEmpty(error.response)){
              this.$helper.toastError(this, "Change Password Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
            }
            else{
              this.$helper.toastError(this, "Change Password Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
            }
          })
          .finally(() => {
            this.isLoading.editPassword = false
          })
        }
      } else{
        this.isLoading.editPassword = false
      }
    },

    editUser(event) {
      event.preventDefault()

      this.isLoading.createEditUser = true
      let isFormValid = true
      let obj = {
        userId: this.selectedUserId
      }
      for(const [key, data] of Object.entries(this.createEditUser)){
        if (key == 'password' || key == 'confirmPassword') {
          continue
        } else if (key == 'jobCode') {
          // The rest of the field
          if (data.isRequired && this.$helper.isEmpty(data.value)) {
            isFormValid = false
            data.isValid = false
          } else{
            data.isValid = null
            obj[data.payloadKey] = data.value.jobCode
          }
        } else{
          // The rest of the field
          if (data.isRequired && this.$helper.isEmpty(data.value)) {
            isFormValid = false
            data.isValid = false
          } else{
            data.isValid = null
            obj[data.payloadKey] = data.value
          }
        }
      }

      if (isFormValid) {
        let postUrl = '/user/edit/'
        // only send axios request if role is valid
        if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
          this.isSubmitting = true
          this.$axios.post(postUrl, obj).then(response => {
            if(response.status == 200){
              this.getUserTableItems(this.userTable.currentPage)
              this.$helper.toastSuccess(this, "Edit User Berhasil! " + (response.data.reason ? response.data.reason : ""))
              this.showCreateEditkUserModal = false
            } else{
              this.$helper.toastError(this, "Edit User Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
            }
          })
          .catch(error => {
            if(!this.$helper.isEmpty(error.response)){
              this.$helper.toastError(this, "Edit User Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
            }
            else{
              this.$helper.toastError(this, "Edit User Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
            }
          })
          .finally(() => {
            this.isLoading.createEditUser = false
          })
        }
      } else{
        this.isLoading.createEditUser = false
      }
    },

    createUser(event) {
      event.preventDefault()

      this.isLoading.createEditUser = true
      let isFormValid = true
      let obj = {}
      for(const [key, data] of Object.entries(this.createEditUser)){
        // Password Minimal 8 karakter, mengandung angka (0 - 9), huruf besar, huruf kecil, dan karakter khusus (+_)(*&^%$#@!~`[]\;‘,./<>?:“{}|)
        if (key == 'password') {
          if (data.isRequired && this.$helper.isEmpty(data.value)) {
            data.feedback = "This input is required."
            isFormValid = false
            data.isValid = false
          } else if (data.value.length < 8) {
            data.feedback = "Password should contain a minimal 8 characters."
            isFormValid = false
            data.isValid = false
          } else if (!this.$helper.containsSmallLetter(data.value) || !this.$helper.containsCapitalLetter(data.value)) {
            data.feedback = "Password should contain small [a-z] and capital [A-Z] letter."
            isFormValid = false
            data.isValid = false
          } else if (!this.$helper.containsNumber(data.value)) {
            data.feedback = "Password should contain number [0-9]."
            isFormValid = false
            data.isValid = false
          } else if (!this.$helper.containsSpecialCharacter(data.value)) {
            data.feedback = "Password should contain special character [ `!@#$%^&*()_+-=[]{};':\"|,.<>/?~ ]."
            isFormValid = false
            data.isValid = false
          } else{
            data.isValid = null
            obj[data.payloadKey] = data.value
          }
        } else if (key == 'confirmPassword') {
          // Repeat Password on confirm password field
          if (data.isRequired && this.$helper.isEmpty(data.value)) {
            data.feedback = "This input is required."
            isFormValid = false
            data.isValid = false
          } else if (data.value != this.createEditUser.password.value) {
            data.feedback = "Please repeat the same password."
            isFormValid = false
            data.isValid = false
          } else{
            data.isValid = null
          }
        } else if (key == 'jobCode') {
          // The rest of the field
          if (data.isRequired && this.$helper.isEmpty(data.value)) {
            isFormValid = false
            data.isValid = false
          } else{
            data.isValid = null
            obj[data.payloadKey] = data.value.jobCode
          }
        } else{
          // The rest of the field
          if (data.isRequired && this.$helper.isEmpty(data.value)) {
            isFormValid = false
            data.isValid = false
          } else{
            data.isValid = null
            obj[data.payloadKey] = data.value
          }
        }
      }

      if (isFormValid) {
        let postUrl = '/user/add/'
        // only send axios request if role is valid
        if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
          this.isSubmitting = true
          this.$axios.post(postUrl, obj).then(response => {
            if(response.status == 200){
              this.resetCreateEditUserFields()
              this.populateSelectJobCode()
              this.getUserTableItems(this.userTable.currentPage)
              this.$helper.toastSuccess(this, "Create User Berhasil! " + (response.data.reason ? response.data.reason : ""))
            } else{
              this.$helper.toastError(this, "Create User Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
            }
          })
          .catch(error => {
            if(!this.$helper.isEmpty(error.response)){
              this.$helper.toastError(this, "Create User Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
            }
            else{
              this.$helper.toastError(this, "Create User Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
          })
          .finally(() => {
            this.isLoading.createEditUser = false
          })
        }
      } else{
        this.isLoading.createEditUser = false
      }
    },

    showLockUnlockUserModal(id, fullName, username, isLocked) {
      this.lockUnlockUser.id = id
      this.lockUnlockUser.fullName = fullName
      this.lockUnlockUser.username = username
      this.lockUnlockUser.lock = !isLocked
      this.showConfirmLockUnlockUserModal = true
    },

    showResetPasswordModal(id, fullName, username, isLocked) {
      this.lockUnlockUser.id = id
      this.lockUnlockUser.fullName = fullName
      this.lockUnlockUser.username = username
      this.lockUnlockUser.lock = !isLocked
      this.showConfirmResetPasswordModal = true
    },

    confirmLockUnlockUser() {
      this.isLoading.confirmLockUnlockUser = true
      let processUrl = "/user/toggleUserLockStatus";
      let data = new FormData();
      data.set('userId', this.lockUnlockUser.id);
      this.$axios.post(processUrl, data).then((response) => {
        if (response.status === 200){
          this.$helper.toastSuccess(this, (this.lockUnlockUser.lock ? "Kunci" : "Buka kunci") + " akun Sukses! " + (response.data.reason ? response.data.reason : ""))
        } else {
          this.$helper.toastError(this, (this.lockUnlockUser.lock ? "Kunci" : "Buka kunci") + " akun Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, (this.lockUnlockUser.lock ? "Kunci" : "Buka kunci") + " akun Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, (this.lockUnlockUser.lock ? "Kunci" : "Buka kunci") + " akun Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.showConfirmLockUnlockUserModal = false
        this.isLoading.confirmLockUnlockUser = false

        if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
          this.getUserTableItems(this.userTable.currentPage)
        }
      });
    },

    confirmResetPassword() {
      this.isLoading.confirmResetPassword = true
      let processUrl = "/user/resetPassword";
      let data = new FormData();
      data.set('userId', this.lockUnlockUser.id);
      this.$axios.post(processUrl, data).then((response) => {
        if (response.status === 200){
          this.$helper.toastSuccess(this, "Reset Password akun Sukses! " + (response.data.reason ? response.data.reason : ""))
        } else {
          this.$helper.toastError(this, "Reset Password akun Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Reset Password akun Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Reset Password akun Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.showConfirmResetPasswordModal = false
        this.isLoading.confirmResetPassword = false
      });
    },

    onChangeFilterType() {
      if (this.userTable.filterType == "isLocked") {
        this.userTable.filterValue = "true"
      } else{
        this.userTable.filterValue = null
      }
    },

    onLimitChange(newPerPage) {
      this.userTable.perPage = newPerPage
      // only fetch data when roles apply
      if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.getUserTableItems()
      }
    },
  
    onPageChange(newPage) {
      // only fetch data when roles apply
      if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.getUserTableItems(newPage)
      }
    },

    onAssignNotaryLimitChange(newPerPage) {
      this.assignNotaryTable.perPage = newPerPage
      // only fetch data when roles apply
      if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.getAssignNotaryTableItems()
      }
    },

    onAssignOfficeLimitChange(newPerPage) {
      this.assignOfficeTable.perPage = newPerPage
      // only fetch data when roles apply
      if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.getAssignOfficeTableItems()
      }
    },
  
    onAssignNotaryPageChange(newPage) {
      // only fetch data when roles apply
      if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.getAssignNotaryTableItems(newPage)
      }
    },
  
    onAssignOfficePageChange(newPage) {
      // only fetch data when roles apply
      if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.getAssignOfficeTableItems(newPage)
      }
    },
  
    onSortChanged(ctx) {
      this.userTable.sort.by = ctx.sortBy
      this.userTable.sort.desc = ctx.sortDesc
      // only fetch data when roles apply
      if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.getUserTableItems(this.userTable.currentPage)
      }
    },

    onAssignNotarySortChanged(ctx) {
      this.assignNotaryTable.sort.by = ctx.sortBy
      this.assignNotaryTable.sort.desc = ctx.sortDesc
      // only fetch data when roles apply
      if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.getAssignNotaryTableItems(this.assignNotaryTable.currentPage)
      }
    },

    onAssignOfficeSortChanged(ctx) {
      this.assignOfficeTable.sort.by = ctx.sortBy
      this.assignOfficeTable.sort.desc = ctx.sortDesc
      // only fetch data when roles apply
      if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.getAssignOfficeTableItems(this.assignOfficeTable.currentPage)
      }
    },
  
    getUserTableItems(page = 1) {
      this.userTable.isLoaded = false
      this.userTable.items = []
      if(isNaN(page)) {
        this.userTable.currentPage = 1
      }
      else {
        this.userTable.currentPage = page
      }
      // URL builder
      let getUrl = "/user/getAll"
      
      let params = this.$helper.getBasePagedQuery(this.userTable.currentPage - 1, this.userTable.perPage)
      if(!this.$helper.isEmpty(this.userTable.filterValue)) {
        params['filterType'] = this.userTable.filterType
        params['filterValue'] = this.userTable.filterValue
      }
      if(this.userTable.sort.by != null) {
        params = this.$helper.getBaseSortQuery(this.userTable.sort, params)
      }

      return this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){
          sessionStorage.setItem("filterUserType", this.userTable.filterType)
          sessionStorage.setItem("filterUserValue", this.userTable.filterValue)
          this.userTable.items = response.data.data.data
          this.userTable.totalRows = response.data.data.totalElements
          this.userTable.totalPages = response.data.data.totalPages
        }
        else{
          // this.errorAction(response)
          this.$helper.toastError(this, "Load Daftar User Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        // this.errorAction(error)
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Daftar User Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Load Daftar User Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.userTable.isLoaded = true
      })
    },
  
    errorAction(error){
      let listError = this.$helper.errorHandling(error);
      this.errorTitle = this.$errorLabel.generic;
      this.errorLabel = 'Terjadi kesalahan: '+listError[0] || 'Unknown Error';
      if (this.errorLabel.toLowerCase().includes('token expired')){
        this.errorLogout = true;
      }
      this.showErrorModal = true;
    },

    // populate select jobcode dropdown dynamically
    populateSelectJobCode(query = "") {
      this.createEditUser.jobCode.isLoaded = false
      this.createEditUser.jobCode.totalPages = 0
      this.createEditUser.jobCode.totalRows = 0
      this.createEditUser.jobCode.currentPage = 1
      this.createEditUser.jobCode.lastQuery = query
      // URL builder
      let getUrl = "/jobCode/getAllNonNotary"
      
      let params = this.$helper.getBasePagedQuery(this.createEditUser.jobCode.currentPage - 1, this.createEditUser.jobCode.perPage)
      if(query !== "") {
        params['filterType'] = "jobName"
        params['filterValue'] = query
      }
      
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            this.createEditUser.jobCode.options = []
            for(let i = 0; i < response.data.data.data.length; i++){
              this.createEditUser.jobCode.options.push(response.data.data.data[i])
            }
            this.createEditUser.jobCode.totalRows = response.data.data.totalElements
            this.createEditUser.jobCode.totalPages = response.data.data.totalPages
          }
          else{
            this.$helper.toastError(this, "Load Daftar Job Code Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Job Code Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Job Code Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.createEditUser.jobCode.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },

    appendSelectJobCode() {
      this.createEditUser.jobCode.isLoaded = false
      let query = this.createEditUser.jobCode.lastQuery
      // URL builder
      let getUrl = "/jobCode/getAllNonNotary"
      
      let params = this.$helper.getBasePagedQuery(this.createEditUser.jobCode.currentPage, this.createEditUser.jobCode.perPage)
      if(query !== "") {
        params['filterType'] = "jobName"
        params['filterValue'] = query
      }
      
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            for(let i = 0; i < response.data.data.data.length; i++){
              this.createEditUser.jobCode.options.push(response.data.data.data[i])
            }
            this.createEditUser.jobCode.currentPage++
          }
          else{
            this.$helper.toastError(this, "Load Daftar Job Code Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Job Code Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Job Code Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.createEditUser.jobCode.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
  },

  created(){
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterUserType"))){
      this.userTable.filterType = sessionStorage.getItem("filterUserType")
    }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterUserValue"))){
      this.userTable.filterValue = sessionStorage.getItem("filterUserValue")
    }
    this.getUserTableItems()
  },
  mounted() {
    this.populateSelectJobCode()
  },
}
</script>

<style>

</style>
